import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { NgxIndexedDBModule } from 'ngx-indexed-db';
import { ToastNoAnimationModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';

import { FormsModule } from '@angular/forms';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { AuthInterceptor } from './interceptors/auth.interceptor/auth.interceptor';
import { CacheService } from './services/cache.service/cache.service';

FullCalendarModule.registerPlugins([interactionPlugin, dayGridPlugin, timeGridPlugin]);

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    SharedModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ToastNoAnimationModule.forRoot(),
    FullCalendarModule,
    HttpClientModule,
    NgxQRCodeModule,
    AngularEditorModule,
    NgxIndexedDBModule.forRoot(CacheService.getConfig())
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
